import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

class Downloadable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { src, button, binary, name } = this.props;
    return (
      <div className="DownloadableImage">
        <img
          className={'image'}
          src={src}
          alt={'Immagine '+ name}
        />
        <div className={'middle'}>
          <a className="mr-2 mb-2 btn btn-primary btn-sm DownloadableImageFile"
             href={`data:image/png;base64,${binary}`}
             target={'_self'}
             download={name}
             aria-label={button}
             >
            {button}
          </a>
        </div>
      </div>
    );
  }
}

Downloadable.defaultProps = {
  button: 'Scarica Immagine',
  name: 'img.jpg',
  binary: null,
};

Downloadable.propTypes = {
  button: PropTypes.string,
  src: PropTypes.string.isRequired,
  name: PropTypes.string,
  binary: PropTypes.any,
};

export default Downloadable;
